import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';

import { AppService } from 'src/app/app.service';
import { TranslationKey } from 'src/app/enums';
import { IInviteContactDialogConfig, IInviteContactDialogResult } from 'src/app/interfaces';
import { InviteContactModalDialogService } from 'src/app/invite-contact-modal-dialog.service';
import { ModalDialogService } from 'src/app/modal-dialog.service';
import { ApiService } from 'src/app/shared/api.service';
import { NotificationMessageType } from 'src/app/shared/enums';
import { IPagedRequest, IPagedResponse, IProfileContact } from 'src/app/shared/interfaces';
import { NotificationsService } from 'src/app/shared/notifications.service';

@Component({
    selector: 'aza-rws-profile-contacts',
    templateUrl: 'contacts.component.html',
    styleUrls: ['contacts.component.css'],
    standalone: false
})
export class ContactsComponent implements OnInit {

  pagedReq: IPagedRequest;
  pagedRes: IPagedResponse;
  contacts: any[] = [];
  pagedResponseSubject = new Subject<IPagedResponse>();
  contactSearchText = '';

  @Output() closed = new EventEmitter<void>();
  @Output() eventClicked = new EventEmitter<any>();

  constructor(
    private apiSvc: ApiService, private inviteContactSvc: InviteContactModalDialogService, private modalDialogSvc: ModalDialogService,
    private appSvc: AppService, private notificationsSvc: NotificationsService
  ) {
  }

  async ngOnInit(): Promise<void> {
    this.pagedRes = { offset: 0, limit: 0, object_count: 0 };
    this.pagedReq = { limit: 5, offset: 0 };
    this.loadContacts(this.pagedReq);
  }

  async loadContacts(pagedReq: IPagedRequest): Promise<void> {
    const res = await this.apiSvc.searchContacts(this.contactSearchText, pagedReq);
    this.contacts = res.contacts;
    this.pagedResponseSubject.next(res);
  }

  async onInviteContact(): Promise<void> {
    let shouldCloseTheDialog = false;
    let inviteContactDialogConfig: IInviteContactDialogConfig = {};
    let inviteContactDialogResult: IInviteContactDialogResult;
    do {
      inviteContactDialogResult = await this.inviteContactSvc.showPopupDialog(inviteContactDialogConfig);
      if (inviteContactDialogResult) {
        inviteContactDialogConfig.email = inviteContactDialogResult.email;
        inviteContactDialogConfig.firstName = inviteContactDialogResult.firstName;
        inviteContactDialogConfig.lastName = inviteContactDialogResult.lastName;
      }
      if (!inviteContactDialogResult) {
        // Cancel was clicked
        this.inviteContactSvc.hidePopupDialog();
        shouldCloseTheDialog = true;
      } else if (!inviteContactDialogResult.email || inviteContactDialogResult.email.indexOf('@') === -1) {
        // Invalid email
        inviteContactDialogResult = null;
        this.inviteContactSvc.hidePopupDialog();
        await this.modalDialogSvc.showPopupDialog({
          firstButton: { id: '', text: 'OK' },
          textLines: [this.appSvc.translate(TranslationKey.invalidEmail)]
        });
        this.modalDialogSvc.hidePopupDialog();
      } else {
        // Result is valid
        this.inviteContactSvc.hidePopupDialog();
        shouldCloseTheDialog = true;
      }
    } while (!shouldCloseTheDialog);
    if (inviteContactDialogResult) {
      await this.apiSvc.inviteContact(
        inviteContactDialogResult.firstName, inviteContactDialogResult.lastName, inviteContactDialogResult.email
      );
      const msg = this.appSvc.translate(TranslationKey.anInvitationHasBeenSent);
      this.notificationsSvc.showNotification(NotificationMessageType.success, msg);
    }
  }

  onFilterChanged(): void {
    // TODO: Debounce
    this.loadContacts(this.pagedReq);
  }

  onPagingOffsetChanged(newOffset: number): void {
    this.pagedReq.offset = newOffset;
    this.loadContacts(this.pagedReq);
  }

  onClosed(): void {
    this.closed.next();
  }

  onContactClick(contact: IProfileContact): void {
    this.eventClicked.next(contact);
  }
}

